import MkuSlider from './src/slider';

MkuSlider.install = function (Vue) {
  Vue.component(MkuSlider.name, MkuSlider);
};

export default MkuSlider;
